{
  "clear": "Puhasta",
  "invalid": "(kehtetu)",
  "loading": "Laadimine...",
  "noResults": "Tulemusi pole"
}
